export const chatOpen = ({ instances = [], source } = {}) => {
  const value = { send_to: instances.map(({ idAnalytics } = {}) => idAnalytics), source };

  window.gtag('event', 'chat_open', value);

  return value;
};
